module.exports = __webpack_public_path__ + "img/FlagForNoResponse.33397893.svg";